module.exports = __webpack_public_path__ + "static/img/医嘱与病历_场景五.dc38c2e7.png";